import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { RemoveRedEye } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "components/Button/Button";
import { Input } from "components/Form";
import ModalBox from "components/modal/ModalBox";
import parse from "html-react-parser";
import TextEditor from "components/TextEditor/TextEditor";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Badge, Fab } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";



import {
    objectTypeChecker,
    rawToHtmlConverter,
    wrapImagesWithFigure,
} from "utils";
import Switch from "components/Switch/Switch";
import {
    addGSChapter,
    editGSChapter,
    getGSChapterById,
    getGSChaptersList,
    updateChapterDisplayorder,
    updateStatusGSChapter,
} from "services/gsfreeresources";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import Link from "components/Button/Link";
import { getPostbyId, getPostCommentsList, getPostList, getUnApprovedPostCommentsList, updateDisplayWebsiteStatus, updatePostComment, updatePostCommentReplyStatus, updatePostCommentStatus, updatePostDisplayorder, updatePostStatus } from "services/blogs/blogs";
import { Badge as BSBadge } from "react-bootstrap";
import { Avatar } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import LikesBadge from "components/ImageLoader/LikeHeart";




export default function ApprovalPendingDashboard() {
    const { postid, posttitle } = useParams();
    const [record, setRecord] = useState([{}]);
    const [limit, setLimit] = useState(10);
    const [activePage, setActivePage] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState("");
    const [displaywebsiteModal, setdisplaywebsiteModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [repliesModal, setRepliesModal] = useState(false);
    const [selectedReplies, setSelectedReplies] = useState([]);
    const [selectedReplyIds, setSelectedReplyIds] = useState([]);



    const [data, setData] = useState({
        // question: EditorState.createEmpty(),
        // explaination: EditorState.createEmpty(),
    });
    const [errorField, setErrorField] = useState({});

    const [viewModal, setViewModal] = useState(false);
    const [shortdescriptionModal, setshortdescriptionModal] = useState(false);
    const [Shortdescription, setshortdescription] = useState(false);
    const [statusModal, setStatusModal] = useState(false);
    const [categoryModal, setcategoryModal] = useState(false);
    const [approveModal, setapproveModal] = useState(false);
    const [categories, setcategories] = useState([]);
    const [editModal, setEditModal] = useState(false);
    const [selectedId, setSelectId] = useState("");
    const [selectedreplyId, setselectedreplyId] = useState("");
    const [selectedpostId, setSelectPostId] = useState("");
    const usertypeid = localStorage.getItem("roleid")
    console.log("usertypeid", usertypeid);


    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [editedDisplayOrder, setEditedDisplayOrder] = useState({});
    const inputRef = useRef(null);
    const [shouldFocusInput, setShouldFocusInput] = useState(true);

    // ***************************************** Fetch Records ********************************************************
    const fetchRecords = async () => {
        showLoader();
        try {
            const res = await getUnApprovedPostCommentsList({
                page: activePage,
                search: search,
                limit: limit,
            });
            hideLoader();
            if (res.code === 200) {
                const { count, rows } = res.data.PostComments;
                setRecord(rows || []);
                setTotal(count || 0);
            } else {
                setRecord([]);
                setTotal(0);
                // toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };
    useEffect(() => {
        fetchRecords();
    }, [search, activePage, limit]);


    const handleApproveComment = async (status) => {
        try {
            const res = await updatePostCommentStatus({
                postid: selectedpostId,
                commentid: selectedId,
                status: status
            });
            if (res.code == 200) {
                setData({});
                setSelectId("");
                setSelectPostId("");
                setapproveModal(false);
                fetchRecords();
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
        } catch (e) {
            toast.error("Failed to Update Status Of Subject");
        }
    };
    const handleApproveCommentReplies = async (status) => {
        try {
 

            const res = await updatePostCommentReplyStatus({
                postid: selectedpostId,
                replyid: selectedId,
                status: status
            });
            console.log("res", res);

            if (res.code == 200) {
                setData({});
                setSelectId("");
                setSelectPostId("");
                setRepliesModal(false);
                setSelectedReplyIds([]);
                setSelectId("");
                setSelectPostId("");
                fetchRecords();
                toast.success(res.message);
            } else {
                toast.error(res.message);
                setRepliesModal(false);
                setSelectedReplyIds([]);
                setSelectId("");
                setSelectPostId("");
            }
        } catch (e) {
            toast.error("Failed to Update Status");
            setRepliesModal(false);
            setSelectedReplyIds([]);
            setSelectId("");
            setSelectPostId("");
        }
    };


    return (
        <>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="search_wrap">
                                <div className="SearchBox mt-1">
                                    {/* <div style={{ marginRight: "10px" }}>
                    <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search}
                      onChange={({ target }) => setSearch(target.value)}
                      type="text"
                    />
                  </div> */}
                                    <div
                                        style={{ display: "flex", justifyContent: "space-between" }}
                                    >
                                        {/* <div>
                      <Button
                        to="add-post"
                        type="acl"
                        role={450006}
                      >
                        Create Post
                      </Button>
                    </div> */}
                                    </div>
                                </div>
                            </div>
                            <h4 className="Title">
                                UnApproved Comments
                            </h4>
                        </div>



                        {loader}
                        <div className="TableList overflow-auto table-responsive">
                            {loader}
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Post</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Comment</th>
                                        <th style={{ textAlign: "center" }}>Type</th>
                                        <th style={{ textAlign: "center" }}>Action</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {record && record.length > 0 ? (
                                        record.map(
                                            (
                                                {
                                                    id,
                                                    postid,
                                                    posttitle,
                                                    name,
                                                    email,
                                                    comment,
                                                    likes,
                                                    approved,
                                                    sectionid,
                                                    replyCount,
                                                    replies,
                                                    type,
                                                    status,
                                                },
                                                i
                                            ) => (
                                                <tr key={i}>
                                                    <td style={{ width: "20px" }}>
                                                        {++i + (activePage - 1) * limit}
                                                    </td>



                                                    <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                        {posttitle || ""}
                                                    </td>
                                                    <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                        {name}
                                                    </td>
                                                    <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                        {email}
                                                    </td>
                                                    <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                        {comment}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        {type}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center">
                                                            <IconButton aria-label="pending" className="px-1 py-0" onClick={() => {
                                                                setSelectId(id);
                                                                setSelectPostId(postid);
                                                                type === "reply" ? setRepliesModal(true) : setapproveModal(true);
                                                            }}>
                                                                <EditIcon sx={{ color: "#4971B2" }} />
                                                            </IconButton>

                                                            {approved == true && (
                                                                <IconButton aria-label="approved" className="px-1 py-0" disabled>
                                                                    <TaskAltIcon sx={{ color: "green" }} />
                                                                </IconButton>
                                                            )}
                                                        </div>
                                                    </td>

                                                </tr>
                                            )
                                        )
                                    ) : (
                                        <NotFound cols={9} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        {total >= 10 ? (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={(e) => setActivePage(e)}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            <ModalBox
                custom={true}
                status={repliesModal}
                onClose={() => setRepliesModal(false)}
                size={"sm"}
                title={"Update Comment Status"}
                description={"Are you sure you want to change the status?"}
                customizedFooter={
                    <>
                        <Button onClick={() => handleApproveCommentReplies(1)}>
                            Approve
                        </Button>
                        {/* <Button onClick={() => handleApproveCommentReplies(0)}>
                            Disapprove
                        </Button> */}

                        <Button
                            className="mx-2"
                            onClick={() => {
                                setRepliesModal(false);
                                setSelectId("");
                                setSelectPostId("");
                            }}
                        >
                            Cancel
                        </Button>
                    </>
                }

            >
            </ModalBox>



            <ModalBox
                custom={true}
                status={approveModal}
                onClose={() => setapproveModal(false)}
                size={"sm"}
                title={"Update Comment Status"}
                description={"Are you sure you want to change the status?"}
                customizedFooter={
                    <>
                        <Button onClick={() => handleApproveComment(1)}>
                            Approve
                        </Button>
                        {/* <Button onClick={() => handleApproveComment(0)}>
                            Disapprove
                        </Button> */}

                        <Button
                            className="mx-2"
                            onClick={() => {
                                setapproveModal(false);
                                setSelectedReplyIds([]);
                                setSelectId("");
                                setSelectPostId("");
                            }}
                        >
                            Cancel
                        </Button>
                    </>
                }
            // custom={false}
            // Close={true}
            />



        </>
    );
}
